
import StatusBar from './StatusBar';
import AppInterface from './AppInterface';

interface PhoneFrameProps {
  onButtonClick: (event: React.MouseEvent) => void;
  buttonRef: React.RefObject<HTMLButtonElement>;
}

const PhoneFrame = ({ onButtonClick, buttonRef }: PhoneFrameProps) => {
  return (
    <div className="relative cursor-pointer transform hover:scale-105 transition-transform duration-300 rotate-3">
      {/* iPhone Frame */}
      <div className="bg-gray-900 rounded-[3rem] p-2 shadow-2xl" style={{ width: '300px', height: '600px' }}>
        {/* Screen */}
        <div className="bg-black rounded-[2.5rem] overflow-hidden h-full relative">
          {/* Dynamic Island */}
          <div className="absolute top-2 left-1/2 transform -translate-x-1/2 w-32 h-6 bg-black rounded-full z-10"></div>
          
          {/* Screen Content */}
          <div className="bg-gradient-to-b from-purple-50 to-white rounded-[2.5rem] h-full overflow-hidden">
            {/* Status Bar */}
            <StatusBar />
            
            {/* App Interface - Reduced spacing */}
            <AppInterface onButtonClick={onButtonClick} buttonRef={buttonRef} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default PhoneFrame;
